<div class="faq-dialog">
  <div class="faq-header">
    <div class="faq-header-title">
      <mat-icon aria-hidden="true">quiz</mat-icon>
      <h2 id="faq-title">Perguntas Frequentes</h2>
    </div>
    <button type="button" class="faq-close" mat-dialog-close aria-label="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="faq-tools">
    <label class="faq-search">
      <span class="sr-only">Pesquisar nas perguntas frequentes</span>
      <mat-icon aria-hidden="true">search</mat-icon>
      <input
        type="search"
        placeholder="Pesquise por palavra-chave, ex.: senha, favorito"
        autocomplete="off"
        [value]="query"
        (input)="onSearch($any($event.target).value)" />
      <button *ngIf="query" type="button" class="faq-search__clear" aria-label="Limpar pesquisa" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    </label>

    <div class="faq-chips" role="group" aria-label="Filtrar por assunto">
      <button type="button" class="faq-chip" [class.is-active]="!activeTopic" [attr.aria-pressed]="!activeTopic" (click)="selectTopic(null)">
        Todos <span class="faq-chip__count">{{ totalMatches }}</span>
      </button>
      <button
        *ngFor="let topic of topics"
        type="button"
        class="faq-chip"
        [class.is-active]="activeTopic === topic"
        [attr.aria-pressed]="activeTopic === topic"
        [disabled]="!topicCounts[topic]"
        (click)="selectTopic(topic)">
        {{ topicLabels[topic] }} <span class="faq-chip__count">{{ topicCounts[topic] }}</span>
      </button>
    </div>
  </div>

  <div class="faq-body" mat-dialog-content>
    <div class="faq-summary">
      <span role="status">{{ visibleCount }} {{ visibleCount === 1 ? 'pergunta' : 'perguntas' }}</span>
      <button *ngIf="visibleCount" type="button" class="faq-link" (click)="toggleAll()">
        {{ allExpanded ? 'Recolher todas' : 'Expandir todas' }}
      </button>
    </div>

    <section *ngFor="let group of groups" class="faq-group" [attr.aria-labelledby]="'faq-group-' + group.topic">
      <h3 class="faq-group__title" [id]="'faq-group-' + group.topic">{{ group.label }}</h3>

      <ul class="faq-list">
        <li *ngFor="let item of group.items" class="faq-item" [class.is-open]="expanded.has(item.id)">
          <h4 class="faq-item__heading">
            <button
              type="button"
              class="faq-item__trigger"
              [id]="'faq-q-' + item.id"
              [attr.aria-expanded]="expanded.has(item.id)"
              [attr.aria-controls]="'faq-a-' + item.id"
              (click)="toggle(item)">
              <span>{{ item.question }}</span>
              <mat-icon class="faq-item__chevron" aria-hidden="true">expand_more</mat-icon>
            </button>
          </h4>
          <div class="faq-item__panel" role="region" [id]="'faq-a-' + item.id" [attr.aria-labelledby]="'faq-q-' + item.id">
            <div class="faq-item__inner">
              <span class="faq-tag">{{ group.label }}</span>
              <p class="faq-answer">{{ item.answer }}</p>
            </div>
          </div>
        </li>
      </ul>
    </section>

    <div *ngIf="!visibleCount" class="faq-empty">
      <mat-icon aria-hidden="true">search_off</mat-icon>
      <p>Nenhuma pergunta encontrada para "{{ query }}".</p>
      <button type="button" class="faq-link" (click)="clearSearch()">Limpar pesquisa</button>
    </div>
  </div>

  <div class="faq-footer">
    <mat-icon aria-hidden="true">chat_bubble_outline</mat-icon>
    <span>Não encontrou o que procurava?</span>
    <a routerLink="/contact-us" mat-dialog-close class="faq-link faq-link--strong">Fale com a Michelin</a>
  </div>
</div>
